import React, { useState } from 'react';
import { Box, Container, Typography, Button, Stack } from '@mui/material';
// useNavigate available from react-router-dom if needed
import { useAnalytics } from '../../../hooks/useAnalytics';
import { useABTest, useABTestConversion } from '../../../hooks/useABTest';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { landingThemeConfig } from '../styles/landingThemeConfig';
import EmailCaptureModal from './EmailCaptureModal';

const StudentCTA = ({ colorTheme = 'teal' }) => {
  // const navigate = useNavigate(); // Available if needed
  const { trackEvent } = useAnalytics();
  const { trackConversion } = useABTestConversion();
  const studentTheme = landingThemeConfig.student(colorTheme);
  const [emailModalOpen, setEmailModalOpen] = useState(false);

  // A/B testing for CTA button text (shared with Hero)
  const { variant: ctaVariant } = useABTest('landing_cta', [
    'variant_a', // Get Early Access
    'variant_b'  // Join the Student Waitlist
  ]);

  const getCTAText = () => {
    if (ctaVariant === 'variant_b') {
      return "Join the Student Waitlist";
    }
    return "Get Early Access";
  };

  const handleCTAClick = () => {
    trackEvent('cta_click', {
      source: 'final_cta',
      cta_variant: ctaVariant
    });
    trackConversion('landing_cta', ctaVariant, 'final_cta_click');
    setEmailModalOpen(true);
  };

  return (
    <Box
      sx={{
        py: { xs: 10, md: 15 },
        position: 'relative',
        backgroundColor: 'transparent', // Let body gradient show through
        overflow: 'hidden',
      }}
    >
      {/* Background decoration */}
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '200%',
          height: '200%',
          background: `radial-gradient(circle, ${studentTheme.components.cta.glowBackground} 0%, transparent 50%)`,
          pointerEvents: 'none',
        }}
      />

      <Container maxWidth="md">
        <Stack spacing={5} alignItems="center" textAlign="center" position="relative">
          <Box>
            <Typography
              variant="h2"
              sx={{
                mb: 2,
                fontWeight: 700,
              }}
            >
              Ready to study smarter, not harder?
            </Typography>
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ fontSize: '1.25rem', mb: 2 }}
            >
              Join the students from leading schools getting ahead
            </Typography>
          </Box>

          <Button
            variant="contained"
            size="large"
            startIcon={<AutoAwesomeIcon />}
            onClick={handleCTAClick}
            sx={{
              py: 2.5,
              px: 6,
              fontSize: '1.375rem',
              animation: 'pulse 2s infinite',
              '@keyframes pulse': {
                '0%': {
                  boxShadow: `0 0 20px ${studentTheme.components.button.primaryShadow}`,
                },
                '50%': {
                  boxShadow: `0 0 40px ${studentTheme.components.button.primaryShadowHover}`,
                },
                '100%': {
                  boxShadow: `0 0 20px ${studentTheme.components.button.primaryShadow}`,
                },
              },
            }}
          >
            {getCTAText()}
          </Button>
        </Stack>
      </Container>
      
      {/* Email Capture Modal */}
      <EmailCaptureModal
        open={emailModalOpen}
        onClose={() => setEmailModalOpen(false)}
        source="final_cta"
        headlineVariant="final_cta" // Final CTA doesn't have headline A/B test
        ctaVariant={ctaVariant}
        colorTheme={colorTheme}
      />
    </Box>
  );
};

export default StudentCTA;